
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Emit } from 'vue-property-decorator';
import logger from '@/logger/logging-button';
import { ActionType } from '@/utils/logTypes';

@Component
export default class CPMissingDocumentsSummary extends Vue {
  @Emit('add')
  public add(): void {
    /* add */
  }

  public close() {
    // this.$store.commit('toggleAlerts', false);
  }

  get missingDocuments() {
    return this.$store.state.missingDocuments.list;
  }

  get missingDocumentsGroups() {
    return this.$store.state.missingDocuments.groups;
  }
  public checkMissingDocs(creationDate: any) {
    // Check if account creation date is more than 6 weeks to date
    const today = new Date();
    const dateNow = new Date(
      [today.getMonth() + 1, today.getDate(), today.getFullYear()].join('/'),
    );
    const days = Math.floor(
      (Date.parse(dateNow.toDateString()) - Date.parse(creationDate)) /
        86400000,
    );
    if (days >= 42) {
      // 42 = 6 weeks
      return true;
    }
    return false;
  }
  public loginAs(id: number) {
    this.$store.dispatch('loginAs', id);

    logger.loggingButton('click', ActionType.LOGIN, 'login AS');
  }
}
